import { struct as l } from "../../../utils/struct/main.js";
import { enumerable as o } from "../../../utils/struct/property.js";
const r = Symbol("<<NO_EXCEPTION>>"), u = (n) => {
  const t = [];
  return l({
    bind: o((e) => function(...i) {
      let c = r;
      try {
        return t.push(e), e.call(this, ...i);
      } catch (a) {
        throw c = a;
      } finally {
        t.pop(), t.length === 0 && c === r && n();
      }
    }),
    effect: o(n)
  });
};
export {
  u as createEffectStack,
  u as default
};
